export const brandLogos = {
  primary: "/brand/logos/gameside-logo.webp",
  vertical: "/brand/logos/gameside-logo-vertical.webp",
  actionGame: "/brand/logos/action-game-logo.webp",
} as const;

export const businessInfo = {
  siteName: "Gameside Caen",
  addressLabel: "350 Rue Paul Boucherot, 14123 Ifs",
  addressLines: ["350 Rue Paul Boucherot", "14123 Ifs"],
  phoneDisplay: "06 72 81 78 99",
  phoneHref: "tel:+33672817899",
  directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=350+Rue+Paul+Boucherot,+14123+Ifs",
  mapEmbedUrl: "https://www.google.com/maps?q=350+Rue+Paul+Boucherot,+14123+Ifs&z=16&output=embed",
  weeklyHours: [
    { day: "Lundi", time: "Fermé" },
    { day: "Mardi", time: "Fermé" },
    { day: "Mercredi", time: "18h - 22h" },
    { day: "Jeudi", time: "18h - 22h" },
    { day: "Vendredi", time: "18h - 23h" },
    { day: "Samedi", time: "14h - 23h" },
    { day: "Dimanche", time: "14h - 18h" },
  ],
} as const;

export const sidebarAssets = {
  logo: "/brand/reference/sidebar-logo.svg",
  pictogram: "/brand/reference/sidebar-pictogram.svg",
  hero: "/brand/reference/sidebar-hero.webp",
  lounge: "/brand/reference/party-bar.webp",
} as const;

export const referenceImages = {
  cards: {
    teamBuilding: "/brand/reference/team-building-card.webp",
    privatisation: "/brand/reference/privatisation-card.webp",
    seminaire: "/brand/reference/seminaire-card.webp",
    evjf: "/brand/reference/evjf-card.webp",
    evg: "/brand/reference/evg-card.webp",
    anniversaireEnfant: "/brand/reference/anniversaire-enfant-card.webp",
    anniversaireAdulte: "/brand/reference/anniversaire-adulte-card.webp",
  },
  teamBuilding: {
    hero: "/brand/reference/team-building-hero.webp",
    intro: "/brand/reference/team-building-gallery-1.webp",
    gallery: [
      "/brand/reference/team-building-gallery-2.webp",
      "/brand/reference/team-building-gallery-3.webp",
      "/brand/reference/team-building-gallery-4.webp",
    ],
  },
  privatisation: {
    hero: "/brand/reference/privatisation-hero.webp",
    intro: "/brand/reference/privatisation-gallery-1.webp",
    gallery: [
      "/brand/reference/privatisation-gallery-1.webp",
      "/brand/reference/privatisation-gallery-2.webp",
      "/brand/reference/privatisation-gallery-3.webp",
    ],
  },
  seminaire: {
    hero: "/brand/reference/seminaire-hero.webp",
    intro: "/brand/reference/seminaire-gallery-1.webp",
    gallery: [
      "/brand/reference/seminaire-gallery-2.webp",
      "/brand/reference/seminaire-gallery-3.webp",
      "/brand/reference/seminaire-gallery-4.webp",
    ],
  },
  evjf: {
    hero: "/brand/reference/evjf-hero.webp",
    feature: "/brand/reference/evjf-feature.webp",
    sidebar: "/brand/reference/evjf-card.webp",
  },
  evg: {
    hero: "/brand/reference/evg-hero.webp",
    feature: "/brand/reference/evg-feature.webp",
    sidebar: "/brand/reference/evg-card.webp",
  },
  anniversaireEnfant: {
    hero: "/brand/reference/anniversaire-enfant-hero.webp",
    feature: "/brand/reference/anniversaire-enfant-feature.webp",
    sidebar: "/brand/reference/anniversaire-enfant-sidebar.webp",
    rooms: [
      "/brand/reference/anniversaire-enfant-room-1.webp",
      "/brand/reference/anniversaire-enfant-room-2.webp",
      "/brand/reference/anniversaire-enfant-room-3.webp",
    ],
  },
  anniversaireAdulte: {
    hero: "/brand/reference/anniversaire-adulte-hero.webp",
    feature: "/brand/reference/anniversaire-adulte-feature.webp",
    sidebar: "/brand/reference/anniversaire-adulte-card.webp",
  },
  partyBar: sidebarAssets.lounge,
} as const;

export const actionGameImages = {
  hero: "/brand/action-game/bataille-navale-hero.webp",
  intro: "/brand/action-game/general-2.webp",
  adultCard: "/brand/action-game/general-1.webp",
  juniorCard: "/brand/action-game/general-2.webp",
  stats: "/brand/action-game/stars-zone-room.webp",
  universes: [
    {
      title: "AZTEC QUEST",
      image: "/brand/action-game/aztec-quest-room.webp",
      pictogram: "/brand/pictograms/aztec-quest.svg",
    },
    {
      title: "MAGIC SCHOOL",
      image: "/brand/action-game/magic-school-room.webp",
      pictogram: "/brand/pictograms/magic-school.svg",
    },
    {
      title: "PIRATE BAY",
      image: "/brand/action-game/pirate-bay-room.webp",
      pictogram: "/brand/pictograms/pirate-bay.svg",
    },
    {
      title: "STARS ZONE",
      image: "/brand/action-game/stars-zone-room.webp",
      pictogram: "/brand/pictograms/stars-zone.svg",
    },
  ],
  gallery: Array.from(
    { length: 72 },
    (_, index) => `/brand/action-game/gallery/photo-${String(index + 1).padStart(2, "0")}.webp`,
  ),
} as const;

export const navigationImages = {
  activites: {
    actionGame: actionGameImages.hero,
    sidebar: sidebarAssets.hero,
    karaoke: sidebarAssets.lounge,
    nextActivity: referenceImages.teamBuilding.gallery[0],
  },
  entreprises: {
    teamBuilding: referenceImages.cards.teamBuilding,
    privatisation: referenceImages.cards.privatisation,
    seminaire: referenceImages.cards.seminaire,
  },
  formules: {
    evgEvjf: referenceImages.cards.evjf,
    evjf: referenceImages.cards.evjf,
    evg: referenceImages.cards.evg,
    anniversaireEnfant: referenceImages.cards.anniversaireEnfant,
    anniversaireAdulte: referenceImages.cards.anniversaireAdulte,
  },
} as const;
